module.exports = __webpack_public_path__ + "static/img/105.d268ea16.png";